// Chat da sala (fila e partida): mensagens vêm do servidor de jogo.
import type { GameStore, RoomChat } from "./game/store";
import { t } from "./i18n";
import { spriteHtml } from "./sprites";
import { esc } from "./ui";
import { currentUser } from "./session";
import { isBlocked, reportButton } from "./report";

/** Monta o chat da sala em `host`. Devolve a função de limpeza. */
export function mountRoomChat(host: HTMLElement, store: GameStore, opts: { compact?: boolean; onMessage?: (m: RoomChat) => void } = {}): () => void {
  host.classList.add("room-chat");
  host.innerHTML = `<ul class="msgs" data-msgs></ul>
    <form class="chat-form"><input class="bw-input" name="text" maxlength="200" autocomplete="off" placeholder="${t("social.say")}"><button class="bw-btn bw-btn--blue">${t("social.send")}</button></form>`;
  const list = host.querySelector<HTMLElement>("[data-msgs]")!;
  const me = currentUser()?.id;
  const line = (m: RoomChat) => {
    if (isBlocked(m.userId)) return "";
    const mine = m.from === store.myId || m.from === store.lobbyId;
    const flag = !mine && m.userId && m.userId !== me ? reportButton(m.userId, m.nickname) : "";
    return `<li class="msg ${mine ? "mine" : ""}">${opts.compact ? "" : spriteHtml(m.avatar ?? 25, 24)}<div><b>${esc(m.nickname)}</b>${flag}: ${esc(m.text)}</div></li>`;
  };
  const redraw = () => {
    list.innerHTML = store.chat.map(line).join("");
    list.scrollTop = list.scrollHeight;
  };
  list.innerHTML = store.chat.map(line).join("");
  list.scrollTop = list.scrollHeight;
  const off = store.onChat((m) => {
    list.insertAdjacentHTML("beforeend", line(m));
    while (list.children.length > 50) list.firstElementChild?.remove();
    list.scrollTop = list.scrollHeight;
    opts.onMessage?.(m);
  });
  host.querySelector("form")!.addEventListener("submit", (e) => {
    e.preventDefault();
    const input = host.querySelector<HTMLInputElement>("input")!;
    const text = input.value.trim();
    if (text) store.sendChat(text);
    input.value = "";
  });
  // teclas digitadas no chat não viram atalhos do jogo
  host.addEventListener("keydown", (e) => e.stopPropagation());
  // denúncia feita daqui leva junto as últimas mensagens da sala e a partida
  const ctx = (e: Event) => {
    const d = (e as CustomEvent<{ matchId?: string; roomChat?: unknown[] }>).detail;
    d.matchId ??= store.matchId ?? undefined;
    d.roomChat ??= store.chat.map((m) => ({ nickname: m.nickname, text: m.text, at: m.at }));
  };
  window.addEventListener("pokechess:report-context", ctx);
  window.addEventListener("pokechess:blocks", redraw);
  return () => {
    off();
    window.removeEventListener("pokechess:report-context", ctx);
    window.removeEventListener("pokechess:blocks", redraw);
  };
}
